import { StyleSheet } from 'react-native';
import { STYLE_VARS } from '../../../../../constants/style-vars';

export const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    position: 'relative',
    padding: 30,
    overflow: 'hidden',
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignSelf: 'center',
  },
  contentWrapper: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  contentName: {
    fontSize: 24,
    fontFamily: STYLE_VARS.iowanOldStyleFont,
    textTransform: 'uppercase',
    color: STYLE_VARS.fccWhite,
    letterSpacing: 2,
    fontWeight: '900',
    textAlign: 'center',
    textShadowColor: 'black',
    textShadowOffset: {width: 1, height: 1},
    textShadowRadius: 10,
  },
  contentBtnWrapper: {
    backgroundColor: STYLE_VARS.primaryColor,
    paddingHorizontal: 20,
    paddingVertical: 12,
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 10,
  },
  contentBtnText: {
    fontSize: 14,
    textTransform: 'uppercase',
    fontFamily: STYLE_VARS.avenirMediumFont,
    fontWeight: '800',
    color: STYLE_VARS.fccWhite,
    lineHeight: 20,
    letterSpacing: 2,
  },
  arrow: {
    width: 10,
    height: 10,
  },
});
